import { atom } from "recoil";

export const updateChargingPointDrawerState = atom({
  key: "updateChargingPointDrawerState", // unique ID (with respect to other atoms/selectors)
  default: null, // default value (aka initial value)
});
